import { render, staticRenderFns } from "./pushMessage.vue?vue&type=template&id=39a9489e"
import script from "./pushMessage.vue?vue&type=script&lang=js"
export * from "./pushMessage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('39a9489e')) {
      api.createRecord('39a9489e', component.options)
    } else {
      api.reload('39a9489e', component.options)
    }
    module.hot.accept("./pushMessage.vue?vue&type=template&id=39a9489e", function () {
      api.rerender('39a9489e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/sys/push/pushMessage.vue"
export default component.exports